import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from '../../services/api.service';
import { PermissionService } from '../../services/permission.service';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-unauthorized',
  imports: [SharedModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent {
  router = inject(Router);
  permissionService = inject(PermissionService);
  apiService = inject(ApiService);

  onUnauthorized(): void {
    if (this.apiService.isLoggedIn()) {
      this.permissionService.loadPermissions().subscribe(() => {
        this.router.navigate(['/']);
      });
    } else if (!this.apiService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }
}
